export default __webpack_public_path__ + "static/ddot-logo-white-36d28ad636e69479d583a2758ef45416.png";